<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Bachelor of Arts</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Bachelor of Arts</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="computer-application ptb--100  horizontal--tab">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <p>Full form of BA is Bachelor of Arts. BA is an extremely popular undergraduate course that students pursue
          right after their class 12th.</p>
        <p>BA is most popular among students of Humanities and there are various specialisations under BA Humanities.
          The list of the most popular specialisations in BA Humanities and the colleges that offfers those
          specialisations is mentioned in the table below.</p>
      </div>
      <div class="col-md-6">
        <div class="table table-responsive mt-3">
          <table class="table table-bordered text-center">
            <thead>
              <tr>
                <th>Sr. No. </th>
                <th>Name of the Subject</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>English</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Hindi</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Geography</td>
              </tr>
              <tr>
                <td>4</td>
                <td>History</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Marathi</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Politics</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Economics</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 text-center">
        <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
      </div>
    </div>
  </div>
</section>
